import { useEffect } from 'react';
import { getSessionInfo } from '../utils/getSessionInfo';
import { Tracking } from '../analytics/tracking';

export const useTrackingInit = () => {
	useEffect(() => {
		const { userInfo } = getSessionInfo();
		if (userInfo?._id) {
			Tracking.identify(userInfo._id, {
				email: userInfo.profile?.email,
				merchantName: userInfo?.merchantName,
				name: `${userInfo.profile?.lastName} ${userInfo?.profile?.firstName} `,
				flags: userInfo.flags,
			});
		}
	}, []);
};
